<template>
  <search-container
    :term="term"
    :results="results"
    :hide-cashback="!$can('cashback_tab')"
    v-bind="$attrs"
    @close="$listeners['close']"
    @update-term="search"
    @submit-term="submit"
    @click-suggestion="clickSuggestion"
    @reset="resetSearch"
  />
</template>

<script>
import * as types from '@store/types'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import axios from 'axios'
import debounce from 'debounce'
import SearchContainer from '@components/Search/SearchContainer'

const search = debounce(function (query) {
  if (typeof this.cancelToken !== typeof undefined) {
    this.cancelToken.cancel('Operation canceled due to new request.')
  }

  this.cancelToken = axios.CancelToken.source()
  this.$store.dispatch(types.SEARCH_SUGGESTIONS, {
    query,
    cancel: this.cancelToken.token
  })
}, 200)

export default {
  components: { SearchContainer },

  data () {
    return {
      cancelToken: undefined
    }
  },

  computed: mapGetters({
    term: types.SEARCH_TERM,
    results: types.SEARCH_SUGGESTIONS
  }),

  mounted () {
    this.clearTerm()
  },

  methods: {
    ...mapMutations({
      clearTerm: types.SEARCH_TERM_CLEAR
    }),
    ...mapActions({
      getFavorites: types.FAVORITES
    }),

    search,

    async submit () {
      const cleanTerm = this.term.replace(/(<([^>]+)>)/ig, '')

      await this.getFavorites()
      this.$router.push({
        name: 'Campanhas',
        query: { query: cleanTerm }
      })

      this.$emit('close')
    },

    clickSuggestion (suggestion) {
      if (suggestion.event === 'award') {
        this.goToAward(suggestion)
      } else if (suggestion.event === 'engagement') {
        this.goToReward(suggestion)
      } else {
        this.goToCampaign(suggestion)
      }

      this.$emit('close')
    },
    goToCampaign (suggestion) {
      this.$router.push({
        name: 'Detalhes da campanha',
        query: { query: this.term },
        params: {
          campaignSlug: suggestion.slug
        }
      })
    },
    goToAward (suggestion) {
      this.$router.push({
        name: 'Detalhes do premio',
        params: {
          partnerSlug: suggestion.partner.slug,
          campaignSlug: suggestion.slug
        }
      })
    },
    goToReward (suggestion) {
      this.$router.push({
        name: 'Detalhes da recompensa',
        params: { partnerSlug: suggestion.partner.slug }
      })
    },
    resetSearch () {
      this.clearTerm()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Search/SearchContainer.vue